<template>
  <div>
    <div v-if="!disabled" class='m-b-20'>
      <el-button size="small" type="primary" @click="openChoose">选择</el-button>
      <el-button size="small" type="default" @click="clearChoose">取消选择</el-button>
    </div>
    <el-input v-model="valueLength" v-show="false"></el-input>
    <el-table
      :data="childValue">
      <el-table-column
        label="操作"
        v-if="!disabled">
        <template scope="scope">
          <el-button type="text" @click="delChoose(scope.$index)">取消选择</el-button>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in visibleFields"
        :prop="field.field_name"
        :label="field.show_name">
      </el-table-column>
    </el-table>
    <el-dialog
      ref="dialog"
      :title="title"
      :size="config.size || 'large'"
      :visible.sync="dialogShow"
      v-if="!disabled">
      <!-- 搜索控件 -->
      <div class="m-b-20">
        <div class="inline-block" v-for="(search, index) in searches">
          <el-input 
            class="w-100"
            v-model="filterData[index].value"
            :placeholder="search.name"
            v-if="search.type == FILTER_INPUT">
          </el-input>
          <el-select 
            clearable
            v-model="filterData[index].value"
            :placeholder="search.name"
            v-if="search.type == FILTER_SELECT">
            <el-option
              v-for="option in search.options"
              :label="option.name"
              :value="option.value">
            </el-option>
          </el-select>
          <range-filter
            :placeholder="search.name"
            v-model="filterData[index]"
            v-if="search.type == FILTER_RANGE">
          </range-filter>
          <datetimerange-filter
            :placeholder="search.name"
            v-model="filterData[index].value" 
            v-if="search.type == FILTER_DATERANGE">
          </datetimerange-filter>
        </div>
        <el-button type="success" @click="beforeGetData" v-if="hasSearch">搜索</el-button>
        <el-button type="success" @click="saveSelect">保存</el-button>
      </div>
      <el-table
        :data="tableData"
        ref="selectTable"
        highlight-current-row
        @current-change="curLineChange"
        @select-all="selectAll"
        @select="singleSelect">
        <el-table-column
          label="选择"
          type="selection"
          width="50"
          v-if="isMultiple">
        </el-table-column>
        <el-table-column
          v-for="field in visibleFields"
          :prop="field.field_name"
          :label="field.show_name">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="m-t-20 m-b-20 ovf-hd">
        <div class="fl">
          <slot name="footer"></slot>
        </div>
        <div class="fr">
          <el-pagination
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page="curPage"
            @current-change="pageChange"
            :total="total">
          </el-pagination>
        </div>
        <div style="clear:both"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   * @param Number value 绑定值
   * @param Number id 控件id
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Object config 关联控件的配置项
   */
  import modelConfig from '../../../../config/modelConfig'
  import cmsConfig from '../../../../config/cmsConfig'
  import http from '../../../../assets/js/http'
  import rangeFilter from '../../../Common/business/filter/rangeFilter'
  import datetimerangeFilter from '../../../Common/business/filter/datetimerangeFilter'
  
  export default {
    props: {
      value: {},
      id: Number,
      name: String,
      title: String,
      disabled: Boolean,
      config: Object,
      isNeed: {},
      rules: {},
      api: {
        type: String,
        default: 'multi_link'
      }
    },
    data() {
      return {
        childValue: [],
        visibleFields: [],
        tableData: [], // 选择列表
        dialogShow: true,
        searches: [], // 搜索控件
        filterData: [], // 筛选数据的条件
        pageSize: 10,
        curPage: 1,
        // selectedIds: [], // 选中的id数组
        selectedDatas: [], // 选中的完整数据
        total: 0,
        selectType: 10, // 10:单选 20:多选
        maxSelect: 0, // 最大选择数和最小选择数
        minSelect: 0,
        postData: {},
        valueLength: 0,
        apiList: {
          multi_link: {
            config: 'multi_config',
            data: 'multi'
          },
          child: {
            config: 'child_config',
            data: 'child'
          }
        }
      }
    },
    methods: {
      initData() {
        if (this.value && this.value.list) {
          this.childValue = _.cloneDeep(this.value.list)
          this.selectedDatas = _.cloneDeep(this.value.list)
          let initValue = _.map(this.selectedDatas, (item) => {
            return item.id
          })
          this.$emit('input', initValue)
        } else {
          this.childValue = []
        }
      },
      /**
       * [初始化配置]
       */
      initConfig() {
        this.pageSize = this.config.page_size || 10
        this.selectType = this.config.select_type
        this.maxSelect = this.config.max_select_num
        this.minSelect = this.config.min_select_num
        this.getConfig()
      },
      setRules() {
        if (this.rules && this.isNeed && this.isMultiple) {
          if (this.minSelect) {
            this.rules[this.name].push({ validator: this.checkMin, trigger: 'change' })
          }
        }
      },
      checkMin(rule, value, callback) {
        if (value.length < this.minSelect) {
          callback(new Error(`请勾选不少于${this.minSelect}个选项`))
        } else {
          callback()
        }
      },
      /**
       * 获取关联配置
       */
      getConfig() {
        this.apiGet(`form/keys/${this.id}/${this.apiList[this.api].config}`).then((res) => {
          if (res.code == 200) {
            this.visibleFields = res.data.display_fields
            this.searches = res.data.search
            this.setFilterData()
          } else {
            _g.dealError(this, res)
          }
        })
      },
      /**
       * 设置筛选条件
       */
      setFilterData() {
        this.filterData = []  // 初始化列表筛选数据
        _(this.searches).forEach((item) => {  // 处理筛选条件
          let filterModel = {}
          if (item.type == this.FILTER_RANGE) {
            filterModel = {
              field_id: item.field_id,
              type: item.type,
              from: '',
              to: ''
            }
          } else if (item.type == this.FILTER_DATERANGE) {
            filterModel = {
              field_id: item.field_id,
              type: item.type,
              value: []
            }
          } else {
            filterModel = {
              field_id: item.field_id,
              value: '',
              type: item.type
            }
          }
          this.filterData.push(filterModel)
        })
      },
      /**
       * 获取搜索条件
       */
      beforeGetData() {
        this.curPage = 1
        let postData = this.makeFilterData(this.filterData)
        this.postData = postData
        this.getData()
      },
      // 构造搜索数据
      makeFilterData(filter) {
        let postData = {}
        let stringFilter = []
        let selectFilter = []
        let rangeFilter = []
        let cloneFilter = _.cloneDeep(filter)
        // 分离下拉框筛选和其他筛选
        _(cloneFilter).forEach((res) => {
          let typeSelect = res.type == this.FILTER_SELECT
          let typeRange = res.type == this.FILTER_RANGE
          let typeDateRange = res.type == this.FILTER_DATERANGE
          if (typeSelect) { // 若是下拉框筛选
            res.value = res.value
            selectFilter.push(res)
          } else if (typeRange && res.from !== '' && res.to !== '') { // 若是范围筛选
            rangeFilter.push(res)
          } else if (typeDateRange) {
            res.from = res.value[0]
            res.to = res.value[1]
            delete res.value
            rangeFilter.push(res)
          } else {  // 其他类型筛选
            stringFilter.push(res)
          }
        })
        postData = {
          filter: stringFilter,
          select: selectFilter,
          range: rangeFilter
        }
        return postData
      },
      /**
       * 获取表格数据
       */
      getData() {
        let params = this.postData
        params.page = this.curPage
        params.pageSize = this.pageSize

        this.apiPost(`form/keys/${this.id}/${this.apiList[this.api].data}`, params).then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.list || []
            this.total = res.data.count
            // 一定要在渲染之后处理选中状态
            this.$nextTick(() => {
              this.checkSelect()
            })
          } else {
            _g.dealError(this, res)
          }
        })
      },
      /**
       * 打开选择弹窗
       */
      openChoose() {
        this.selectedDatas = _.cloneDeep(this.childValue)
        this.getData()
        this.$refs.dialog.open()
      },
      /**
       * 清除所有选择的结果
       */
      clearChoose() {
        this.$confirm('会清空已选择的内容，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.childValue = []
          this.selectedDatas = []
          this.checkSelect()
        })
      },
      delChoose(index) {
        this.childValue.splice(index, 1)
      },
      /**
       * 更新已选列表
       */
      selectChange(val, row) {
        // 单行取消选择
        if (row) {
          let index = this.selectedIds.indexOf(row.id)
          if (index >= 0) {
            this.selectedDatas.splice(index, 1)
            return
          }
        }
        // 判断是否出现在已选列表中
        _(val).forEach((item) => {
          if (this.selectedIds.indexOf(item.id) < 0) {
            this.selectedDatas.push(item)
          }
        })
      },
      /**
       * 选择单行时数据变化
       */
      singleSelect(val ,row) {
        if (this.isMultiple && this.maxSelect) {
          let oldLen = this.selectedIds.length
          let newLen = this.selectedIds.indexOf(row.id) >= 0 ? oldLen - 1 : oldLen + 1
          if (newLen > this.maxSelect) {
            _g.toastMsg(this, 'error', `最多选择${this.maxSelect}条！`)
            // 清除选择状态
            this.$refs.selectTable.toggleRowSelection(row, false)
            return
          }
        }
        this.selectChange(val, row)
      },
      /**
       * 多选的情况下判断是否超出限制
       */
      selectAll(val) {
        if (val.length <= 0) { // 跳过取消全选
          return
        }
        // 判断现在选中的和已选的有几条重合
        let hasSelected = 0
        _(this.tableData).forEach((item, index) => {
          if (this.selectedIds.indexOf(item.id) >= 0) {
            hasSelected++
          }
        })
        if (this.isMultiple && this.maxSelect) {
          let newLen = this.selectedIds.length - hasSelected + this.tableData.length
          if (newLen > this.maxSelect) {
            _g.toastMsg(this, 'error', `最多选择${this.maxSelect}条！`)
            // 清除选择状态
            this.$refs.selectTable.clearSelection()
            return
          }
        }
        this.selectChange(val)
      },
      /**
       * 选择类型为单选的时候需要当前选择行
       */
      curLineChange(currentRow, oldCurrentRow) {
        if (this.isMultiple) {
          return
        }
        // this.selectedIds = []
        this.selectedDatas = []
        // this.selectedIds.push(currentRow.id)
        this.selectedDatas.push(currentRow)
      },
      /**
       * 更新当前数据的选中状态
       */
      checkSelect() {
        if (this.isMultiple) {
          _(this.tableData).forEach((item, index) => {
            if (this.selectedIds.indexOf(item.id) >= 0) {
              this.$refs.selectTable.toggleRowSelection(this.tableData[index], true)
            } else {
              this.$refs.selectTable.toggleRowSelection(this.tableData[index], false)
            }
          })
        }
      },
      /**
       * 分页请求新的数据
       */
      pageChange(curPage) {
        this.curPage = curPage
        this.getData()
      },
      /**
       * 保存当前选择结果
       */
      saveSelect() {
        this.childValue = _.cloneDeep(this.selectedDatas)
        this.$refs.dialog.close()
        _g.toastMsg(this, 'success', '保存成功')
      }
    },
    created() {
      this.initData()
      this.initConfig()
      this.setRules()
    },
    computed: {
      isSingle() {
        return this.selectType === 10
      },
      isMultiple() {
        return this.selectType === 20
      },
      hasSearch() {
        return this.searches && this.searches.length > 0
      },
      selectedIds() {
        return _.map(this.selectedDatas, (item) => {
          return item.id
        })
      }
    },
    watch: {
      childValue(val) {
        this.valueLength = val ? val.length : 0
        let ids = _.map(val, (item) => {
          return item.id
        })
        this.$emit('input', ids)
      }
    },
    components: {
      rangeFilter,
      datetimerangeFilter
    },
    mixins: [http, modelConfig, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// honrayRelate.vue?04ea5522